import React, { useState, useEffect,useRef } from 'react';
import './NavigationBar.css';
import { MdMenu, MdClose } from 'react-icons/md';
import { FaInstagram, FaFacebookF } from 'react-icons/fa';
import { SOCIAL_LINKS } from '../config/socialLinks';
import NavigationPage from './NavigationPage';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';
import logo from '../assets/photos/logo-missive-green-final.png'; 
import logo_gold from '../assets/photos/logo-missive-bright.png'; 
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll';
import { Link, useLocation  } from 'react-router-dom';
import CustomLink from './CustomLink';

const NavigationBar = ({ bgColor,activeDiv, setActiveDiv }) => {
    const { t, language } = useLanguage();
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [shrinkNav, setShrinkNav] = useState(false);
    const [activeMenu, setActiveMenu] = useState(null);
    let borgerColor;

useEffect(() => {
  let lastScrollY = 0;
  let ticking = false;

  const updateScrollState = () => {
    const currentScrollY = window.scrollY;
    const threshold = 25;

    if (currentScrollY > lastScrollY + threshold) {
      setShrinkNav(true);
    } else if (currentScrollY + threshold < lastScrollY) {
      setShrinkNav(false);
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  const handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  };

  window.addEventListener('scroll', handleScroll);
  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
}, []);

  
    const toggleNavigation = () => {
        setIsNavOpen(!isNavOpen);
    };
    if(bgColor === 'white') { borgerColor='#2d2d2d'} else { borgerColor='white'}

    // ---reservation system for desktop:
    const [showBookingOverlay, setShowBookingOverlay] = useState(false);
    const sboxRef = useRef(null);   

    const doClickSearchNav = ()=> {
        setShowBookingOverlay(true);
        setActiveDiv('div2');
    }
    
    // --END reservation system for desktop:
    // {console.log('divid:')}
    const location = useLocation();
    //{console.log(location)}
    useEffect(() => {
      if (location.state && location.state.scrollTo) {
        const sectionId = location.state.scrollTo;
  
        // Add a delay to allow the page content to render
        setTimeout(() => {
          // Use the native DOM API to scroll to the element
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    }, [location]);
    

    return (
      <nav className={`nav-bar ${shrinkNav ? 'shrink' : ''} ${language === 'en' ? 'nav-ltr' : ''}`}  style={{ backgroundColor: bgColor, borderColor:bgColor }}>
          {/* Title */}
          {/* <h1 className="title">Your Title</h1> */}
          {bgColor === 'white' ? 
            <Link to={'/'} onClick={() => {window.scroll(0, 0);}}><img className={`logoclass ${shrinkNav ? 'shrink' : ''}`} src={logo} alt="Logo" /></Link> :
            <Link to={'/'} onClick={() => {window.scroll(0, 0);}}><img className={`logoclass ${shrinkNav ? 'shrink' : ''}`} src={logo_gold} alt="Logo" /></Link>
          }
          {/* Desktop Navigation */}
          <div className="desktop-nav-container">
            {/* Desktop Hamburger Icon before all menu items */}
            <div className="desktop-hamburger-icon" onClick={toggleNavigation} style={{ color: borgerColor }}>
                {isNavOpen ? <MdClose /> : <MdMenu />}
            </div>
            
            <ul className="desktop-menu">
                <li className={activeMenu === 'home' ? 'active' : ''} onClick={() => setActiveMenu('home')}><CustomLink to="/" section="welcome">{t('navigation.home')}</CustomLink></li>
                {/* <li className={activeMenu === 'orders' ? 'active' : ''} onClick={() => setActiveMenu('orders')}><a href="#orders" style={{ color: borgerColor }}>הזמנות</a></li> */}
                <li className={activeMenu === 'photos' ? 'active' : ''} onClick={() => setActiveMenu('photos')}><CustomLink to="/" section="gallery-photos" style={{ color: borgerColor }}>{t('navigation.photos')}</CustomLink></li>
                <li className={activeMenu === 'suites' ? 'active' : ''} onClick={() => setActiveMenu('suites')}><CustomLink to="/" section="room-type" style={{ color: borgerColor }}>{t('navigation.suites')}</CustomLink></li>
                <li className={activeMenu === 'estate' ? 'active' : ''} onClick={() => setActiveMenu('estate')}><Link to={'/LuxuryVilla'} onClick={() => {window.scroll(0, 0);}} style={{ color: borgerColor }}>{t('navigation.estate')}</Link></li>
                <li className={activeMenu === 'virtual-tour' ? 'active' : ''} onClick={() => setActiveMenu('virtual-tour')}><Link to={'/VirtualTour'} onClick={() => {window.scroll(0, 0);}} style={{ color: borgerColor }}>{t('navigation.virtualTour')}</Link></li>
                <li className="nav-social-item"><a className="nav-social-link" href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" style={{ color: borgerColor }}><FaInstagram /></a></li>
                <li className="nav-social-item"><a className="nav-social-link" href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={{ color: borgerColor }}><FaFacebookF /></a></li>
            </ul>
          </div>
          

          {/* Hamburger Icon for Mobile */}
          <div className="hamburger-icon" onClick={toggleNavigation}  style={{ color: borgerColor }} >
              {isNavOpen ? <MdClose /> : <MdMenu />}
          </div>

          {/* Mobile Navigation */}
          <div className={`navigation-page ${isNavOpen ? 'open' : ''}`}>
              <NavigationPage closeNav={toggleNavigation} setIsNavOpen={setIsNavOpen} />
          </div>
          {/* reservasion system for desktop */}

            <button 
              className={`floating-button-desk ${isNavOpen ? 'menu-open-hidden' : ''} ${bgColor !== 'white' ? 'dark-theme' : ''} ${shrinkNav ? 'shrink' : ''}`}
              onClick={doClickSearchNav} 
              style={{ 
                zIndex: isNavOpen ? 500 : 999
              }}>
            {t('navigation.bookVacation')}
            </button>

            <div className={`booking-overlay ${showBookingOverlay ? 'show' : ''}`} id="booking-overlay2" data-lenis-prevent style={{direction: language === 'he' ? 'rtl' : 'ltr'}}>
                <button className="close-button" onClick={() => {setShowBookingOverlay(false);}}><MdClose /></button>
                <h3 style={{textAlign: 'center'}}>{t('navigation.selectDates')}</h3>
                <div className='bo-wrap'>
                    {activeDiv === 'div2' && <div key={language} ref={sboxRef} id="sbox" data-url={`https://bookingresults.com/2020.hamakom-suites/actionUrl?lang=${language === 'he' ? 'heb' : 'en'}`}></div>}
                    
                
                </div>
                {/* Include booking form or other content here */}
            </div>
            <div className="nav-end-cluster">
              <a className="phone-bar" href="tel:+97249806006"><span>{t('navigation.phone')}<span className="phone-icon">📞</span></span></a>
              <LanguageSwitcher bgColor={bgColor} />
            </div>

      </nav>
  );
};

export default NavigationBar;






